import classNames from "classnames";
import {FiCheck, FiRotateCcw} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {AnalyzerPhase, AnalyzerPollAnswerChipProps} from "@/pages/analyzer/Analyzer.types.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerPollAnswerChip.module.scss";

export const AnalyzerPollAnswerChip = ({event, answer, superseded, className}: AnalyzerPollAnswerChipProps) => {
  const {phase, pollEdit, handleAnswer, startPollEdit} = useAnalyzerContext();
  const actionsDisabled = phase === AnalyzerPhase.STREAMING || !!pollEdit;

  return (
    <div className={classNames(styles.chip, {[styles.superseded]: superseded}, className)}>
      <Icon icon={FiCheck} size="normal" removeDivDimensions className={styles.check} />
      <div className={styles.text}>
        <div className={styles.topic}>{event.topic}</div>
        <div className={styles.answer}>{answer}</div>
      </div>
      {superseded ? (
        <div className={styles.updatedTag}>Updated</div>
      ) : (
        <div className={styles.actions}>
          <IconButton
            icon={FiRotateCcw}
            variant="secondary"
            size="extraSmall"
            className={styles.actionButton}
            aria-label="Retry with the same answer"
            title="Retry with the same answer"
            disabled={actionsDisabled}
            onClick={() => handleAnswer(answer, event)}
          />
          <Button
            variant="secondary"
            size="extraSmall"
            className={styles.actionButton}
            disabled={actionsDisabled}
            onClick={() => startPollEdit(event)}
          >
            Change
          </Button>
        </div>
      )}
    </div>
  );
};
